import styled from "styled-components";
export const CardFather = styled.div`
  height: 500px;
  border-radius: 10px;
  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.06);
  position: relative;
  .top-section {
    height: 50%;
    padding: 25px;
    border-radius: 10px;
    background-color: ${({ bgColor }) => bgColor};
    color: #fff;
  }
`;

export const Wrapper = styled.div`
  padding: 20px;
  min-height: 300px;
  background-color: ${({ theme }) => theme.backgroundSidebar};
  width: 80%;
  box-shadow: 0px 1px 10px #00000010;
  border-radius: 10px;
  margin: 0 auto;
  margin-top: -79px;
  .box-holder {
    width: 100%;
    margin: 0 auto;
    padding: 10px;
    border-radius: 5px;
    display: flex;
    .img-holder {
      width: 14%;
      text-align: center;
      background-color: #e2edfb;
      padding: 11px 0px 8px 0px;
      border-radius: 11px;
      img {
        width: 60%;
      }
    }
    .content {
      width: 76%;
    }
    .icon {
      margin: 15px 0px 0px 0px;
      width: 8%;
    }
  }
`;
